import React from "react";
import Header from "../common/Header";

import LogoutContacts from "./LogoutContacts";

const LogoutPage = () => {
  return (
    <>
      <div className="bg-light_purple7 rounded-2xl h-[calc(100vh-32px)] overflow-x-hidden">
        <div className="px-3 xs:px-5 relative overflow-x-hidden pb-3">
          <div className=" overflow-hidden">
            <Header text="Logged Connections" />
          </div>
          <div className="pt-[22px]">
            <LogoutContacts />
          </div>
        </div>
      </div>
    </>
  );
};

export default LogoutPage;
